
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1411Dialog extends Serenity.EntityDialog<Report_1411Row, any> {
        protected getFormKey() { return Report_1411Form.formKey; }
        protected getIdProperty() { return Report_1411Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1411Row.localTextPrefix; }
        protected getNameProperty() { return Report_1411Row.nameProperty; }
        protected getService() { return Report_1411Service.baseUrl; }
        protected getDeletePermission() { return Report_1411Row.deletePermission; }
        protected getInsertPermission() { return Report_1411Row.insertPermission; }
        protected getUpdatePermission() { return Report_1411Row.updatePermission; }

        protected form = new Report_1411Form(this.idPrefix);

    }
}